import React from 'react';
import { Box, Button, useTranslations } from '@harea/component';

interface PaymentMethod {
    type: string;
    name: string;
    last4: string;
    expiry: string;
}

interface PaymentMethodContainerProps {
    paymentMethod?: PaymentMethod | null;
    isLoading?: boolean;
}

const PaymentMethodContainer = ({ paymentMethod, isLoading = false }: PaymentMethodContainerProps) => {
    
    const [ TITLE, ADD_BUTTON, LOADING, EMPTY_TITLE, EMPTY_DESC, METHOD_USED, NAME, LAST_DIGITS, EXPIRY_DATE, CHANGE_BUTTON ] = useTranslations(i18n)
    const buttonStyle = "border border-primary rounded-md text-primary";
    const containerStyle = "flex flex-col mx-auto w-fit";

    if (isLoading) {
        return (
            <div className={containerStyle}>
                <h3 className='mb-2 text-primary !flex !items-center gap-2'>{TITLE}</h3>
                <Box>{LOADING}</Box>
            </div>
        );
    }

    if (!paymentMethod) {
        return (
            <div className={containerStyle}>
                <h3 className='mb-2 text-primary !flex gap-2'>{TITLE}</h3>
                <Box>
                    <div className="p-4">
                        <p className="mb-2">{EMPTY_TITLE}</p>
                        <p className="text-sm text-gray-500 mb-4">
                            {EMPTY_DESC}
                        </p>
                        <Button className={buttonStyle}>{ADD_BUTTON}</Button>
                    </div>
                </Box>
            </div>
        );
    }

    return (
        <div className={containerStyle}>
            <h3 className='mb-2 text-primary !flex !items-center gap-2'>{TITLE}</h3>
            <Box>
                <div className="p-4">
                    <div className="mb-4">
                        <p><strong>{METHOD_USED} :</strong> {paymentMethod.type}</p>
                        <p><strong>{NAME} :</strong> {paymentMethod.name}</p>
                        <p><strong>{LAST_DIGITS} :</strong> **** {paymentMethod.last4}</p>
                        <p><strong>{EXPIRY_DATE} :</strong> {paymentMethod.expiry}</p>
                    </div>
                    <Button className={buttonStyle}>{CHANGE_BUTTON}</Button>
                </div>
            </Box>
        </div>
    );
};

export default PaymentMethodContainer;

const i18n = [
    'paying.payment.method.title',
    'paying.payment.method.add.button',
    'std_loading',
    'std_no_payment_method',
    'std_payment_method_hint',
    'std_method_used',
    'std_name',
    'std_last_digits',
    'std_expiry_date',
    'std_change_payment_method',
]